const PolicyTermViewPage = () => {
  return <></>;
};

export default PolicyTermViewPage;
